export class ValidateStatment {
    PatientStatementId: number;
    SelectedIssueDate: Date
}
